import styled from '@emotion/styled'

import { breakpoints, spacing } from '@cash-design-system/react'

const RecoveryCodeContainer = styled.div`
  display: grid;
  grid-gap: ${spacing.xl};
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  ${breakpoints.tablet} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`

const RecoveryCodeWrapper = styled.div`
  background: ${props => props.theme.colors.bannerBackgroundSuccess};
  border-radius: 1.5rem;
  color: ${props => props.theme.colors.primary};
  padding: ${({ theme }) => `${theme.spacing.xs} ${theme.spacing.m}`};
  text-align: center;
  width: fit-content;
  ${props => props.theme.typography.labelMedium};
`

export const RecoveryCodes = ({ recoveryCodes }: { recoveryCodes: string[] }) => {
  return (
    <RecoveryCodeContainer data-testid="recovery-codes">
      {recoveryCodes.map((recoveryCode, i) => (
        <RecoveryCodeWrapper key={`recovery-code-${i}`}>{recoveryCode}</RecoveryCodeWrapper>
      ))}
    </RecoveryCodeContainer>
  )
}
